import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectProductionData = state => selectState(state).data;
export const selectedProduct = state => selectState(state).product;
export const getPrinters = state => selectState(state).printersdata;
export const selectProductionLoading = state => selectState(state).loading;
export const selectfetchProductionLoading = state => selectState(state).productionLoading;
export const selectProductionError = state => selectState(state).error;
export const selectProductionFilterVisible = state => selectState(state).filterVisible;
export const selectProductionFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectProductionSubmitLoading = state => selectState(state).productSubmitloading;
export const selectFilteredProductions = createSelector(
  [selectProductionData, selectProductionFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
